import { render, staticRenderFns } from "./WhiteLabelCard.vue?vue&type=template&id=c2e49baa&scoped=true"
import script from "./WhiteLabelCard.vue?vue&type=script&lang=js"
export * from "./WhiteLabelCard.vue?vue&type=script&lang=js"
import style0 from "./WhiteLabelCard.vue?vue&type=style&index=0&id=c2e49baa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e49baa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2e49baa')) {
      api.createRecord('c2e49baa', component.options)
    } else {
      api.reload('c2e49baa', component.options)
    }
    module.hot.accept("./WhiteLabelCard.vue?vue&type=template&id=c2e49baa&scoped=true", function () {
      api.rerender('c2e49baa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment/Components/Sections/Plans/WhiteLabelCard.vue"
export default component.exports